/* FROUNDER INDIA — motion layer (frin-fx.js). Pairs with frin-fx.css. Display only; touches no product data. */
(function(){
  if(window.__frinFx)return;window.__frinFx=1;
  var fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var motion=window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function io(cb,opts){return ('IntersectionObserver' in window)?new IntersectionObserver(cb,opts):null}

  /* 1. text reveal — split headings into words once, reveal when they enter the viewport */
  var TR='[id^=fih-] h1,[id^=fih-] p,.fi-head h2,[id^=fim-] h2,[id^=fib-] h2,[id^=fis-] h2,[id^=fpx-] h2,[id^=fic-] h1';
  var trObs=io(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');trObs.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
  function splitWords(el){
    if(el.classList.contains('fi-tr')||el.querySelector('*'))return; /* skip if it holds markup */
    var words=el.textContent.split(/(\s+)/),i=0,html='';
    words.forEach(function(w){if(!w)return;if(/^\s+$/.test(w)){html+=w;return}html+='<span class="w" style="--i:'+(i++)+'">'+w.replace(/[<>&]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;'}[c]})+'</span>'});
    el.innerHTML=html;el.classList.add('fi-tr');
    if(trObs&&motion)trObs.observe(el);else el.classList.add('on');
  }
  function textReveal(){if(!motion)return;$$(TR).forEach(splitWords)}

  /* 2. spotlight tiles */
  var SPOT='.trust .t,.cards .card,.fi-perk,[id^=fim-] .step,[id^=fpx-] .box';
  function spot(){
    if(!fine)return;
    $$(SPOT).forEach(function(el){if(el.__spot)return;el.__spot=1;el.classList.add('fi-spot');
      el.addEventListener('mousemove',function(ev){var r=el.getBoundingClientRect();el.style.setProperty('--mx',(ev.clientX-r.left)+'px');el.style.setProperty('--my',(ev.clientY-r.top)+'px')},{passive:true})});
  }

  /* 4. magnetic buttons */
  var MAG='.fi-pill,.add-to-cart-button,.fi-arrows button,[id^=fih-] .cta a';
  function magnetic(){
    if(!fine||!motion)return;
    $$(MAG).forEach(function(b){if(b.__mag)return;b.__mag=1;b.classList.add('fi-mag');
      b.addEventListener('mousemove',function(ev){var r=b.getBoundingClientRect();var dx=(ev.clientX-(r.left+r.width/2))/r.width,dy=(ev.clientY-(r.top+r.height/2))/r.height;b.classList.add('live');b.style.transform='translate('+(dx*10).toFixed(1)+'px,'+(dy*8).toFixed(1)+'px)'},{passive:true});
      b.addEventListener('mouseleave',function(){b.classList.remove('live');b.style.transform=''});
    });
  }

  /* 5. tracing beam through the craftsmanship steps */
  function beam(){
    $$('[id^=fim-] .steps').forEach(function(s){
      if(s.__beam)return;s.__beam=1;s.classList.add('fi-beam');
      var steps=$$('.step',s);
      var so=io(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('seen');so.unobserve(e.target)}})},{rootMargin:'0px 0px -10% 0px'});
      steps.forEach(function(st,i){st.style.transitionDelay=(i*90)+'ms';if(so&&motion)so.observe(st);else st.classList.add('seen')});
      function tick(){
        var r=s.getBoundingClientRect(),vh=window.innerHeight||800;
        var p=(vh*0.72-r.top)/r.height;p=Math.max(0,Math.min(1,p));
        s.style.setProperty('--fi-beam',(p*100).toFixed(1)+'%');
        var tip=r.top+r.height*p;
        steps.forEach(function(st){var b=st.getBoundingClientRect();st.classList.toggle('lit',b.top+b.height/2<=tip+2)});
      }
      var tk;window.addEventListener('scroll',function(){if(tk)return;tk=setTimeout(function(){tk=0;tick()},40)},{passive:true});window.addEventListener('resize',tick);tick();[500,1600,3600].forEach(function(t){setTimeout(tick,t)});
    });
  }

  /* 6. hero cursor parallax */
  function parallax(){
    if(!fine||!motion)return;
    $$('[id^=fih-]').forEach(function(h){if(h.__px)return;h.__px=1;h.classList.add('fi-px');
      h.addEventListener('mousemove',function(ev){var r=h.getBoundingClientRect();var dx=(ev.clientX-r.left)/r.width-.5,dy=(ev.clientY-r.top)/r.height-.5;h.classList.add('live');h.style.setProperty('--px',(-dx*18).toFixed(1)+'px');h.style.setProperty('--py',(-dy*14).toFixed(1)+'px')},{passive:true});
      h.addEventListener('mouseleave',function(){h.classList.remove('live');h.style.setProperty('--px','0px');h.style.setProperty('--py','0px')});
    });
  }

  /* 7. sections ease in */
  var IN='[id^=fir-] .fi-head,[id^=fir-] .fi-rail,[id^=fib-] .band,[id^=fis-] .grid,[id^=fim-] .hand,[id^=fit-] .trust,[id^=fpx-] .grid,[id^=fpx-] .cards';
  var inObs=io(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');inObs.unobserve(e.target)}})},{rootMargin:'0px 0px -6% 0px'});
  function easeIn(){
    if(!motion||!inObs)return;
    $$(IN).forEach(function(el){if(el.__in)return;el.__in=1;var r=el.getBoundingClientRect();if(r.top<(window.innerHeight||800)*0.9){return}el.classList.add('fi-in');inObs.observe(el)});
  }

  /* 8. safety sweep — reveals anything in view even if IntersectionObserver never fires (hidden tabs, old browsers) */
  function sweep(){
    var vh=(window.innerHeight||800)*0.96;
    $$('.fi-tr:not(.on),.fi-in:not(.on)').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<vh&&r.bottom>0)el.classList.add('on')});
    $$('.fi-beam .step:not(.seen)').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<vh&&r.bottom>0)el.classList.add('seen')});
  }
  var sw;window.addEventListener('scroll',function(){if(sw)return;sw=setTimeout(function(){sw=0;sweep()},40)},{passive:true});
  document.addEventListener('visibilitychange',function(){setTimeout(sweep,50)});
  [400,1500,3500,6000].forEach(function(t){setTimeout(sweep,t)});

  function init(){try{textReveal();spot();magnetic();beam();parallax();easeIn()}catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  [300,1200,3000].forEach(function(t){setTimeout(init,t)});
  document.addEventListener('shopify:section:load',init);
})();
